import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CreateReturnOrderComponent = loadable(
  () => import("../../components/ReturnOrders/CreateReturnOrder")
);
import { useNavigate } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
const CreateReturnOrder = () => {
  const navigate = useNavigate();
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["return-order"],
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.RTV_ORDER}`;
    let formData = {
      ...values,
      type: "rtv",
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status == 201) {
        console.log(res?.data);
        navigate(`/edit/${res?.data?.id}`);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const { data: profile, isLoading } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create RTV/Return
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <CreateReturnOrderComponent
          isLoading={isPostLoading}
          handleCreate={handleCreate}
          defaultBranch={profile?.default_branch}
        />
      )}
    </>
  );
};
export default CreateReturnOrder;
